export default __webpack_public_path__ + "static/media/HraGroupIcon.58df8a0a.png";